<template>
    <div class="content">
        <div class="container-fluid">
            <PageTitle :title="$t('CRMDashboard.dashboard')">
                <template v-slot:left>
                    <i class="fas fa-chart-line fa-3x text-crm"/>
                </template>
            </PageTitle>
        </div>
    </div>
</template>

<script>
import PageTitle from "../../shared/misc/PageTitle";
export default {
    name: "CRMDashboard",
    components: {PageTitle},
};
</script>

<style scoped>

</style>